/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export function getProductDetailsURL(reviewsURL: string) {
  return reviewsURL.replace(/^p\/reviews\/|\/p\/reviews\//, '/p/');
}
